/**
 * The decoded material (`StandardMaterial3DData`) and the three-flavoured view
 * both renderers apply (`StandardMaterial3DScalars`). Every `three` reference is
 * type-only, so `index.ts` re-exports this module with no renderer in a linter's
 * import closure (`walkImportClosure` skips erased imports; ADR-0031).
 */
import { BASE_MATERIAL_3D_DEFAULTS } from '../../../godot/scene/baseMaterial3D';
/** Godot's height mapping defaults (`material.cpp:3952`, `:3995-3997`). */
export const HEIGHTMAP_DEFAULTS = {
    scale: BASE_MATERIAL_3D_DEFAULTS.heightmapScale,
    isDeep: false,
    layers: [BASE_MATERIAL_3D_DEFAULTS.heightmapMinLayers, BASE_MATERIAL_3D_DEFAULTS.heightmapMaxLayers],
    flip: [1, 1],
    readsHeight: false,
};
/**
 * The texture slots this slice renders, in the order the component's hooks call
 * them, keyed by Godot property name. The other `BaseMaterial3D` slots (detail,
 * backlight, refraction, clearcoat, subsurface scattering, transmittance) have no
 * wired three analogue, so a reference to one has nothing to apply it.
 */
export const TEXTURE_SLOTS = [
    'albedo_texture',
    'normal_texture',
    'roughness_texture',
    'metallic_texture',
    'emission_texture',
    'ao_texture',
    'heightmap_texture',
    'anisotropy_flowmap',
];
/** The constructor's one-cell flipbook (`material.cpp:3967-3969`). */
export const PARTICLES_ANIM_DEFAULTS = Object.freeze({ hFrames: 1, vFrames: 1, loop: false });
//# sourceMappingURL=types.js.map